import React, { useState, useEffect } from "react";

const Support = () => {
    const [text, setText] = useState("Send");
    const [sent, setSent] = useState(false);
    const [form, setForm] = useState({
        email: "",
        question: ""
    })

    const submitForm = async () => {
        if (sent || text === "Sending") {
            return;
        }
        
        if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setText("Invalid Email");
            return;
        }

        if (!form.question) {
            setText("Invalid Question")
        }

        if (form.question.length > 1000) {
            setText("Question Too Long")
        }

        try {
            setText("Sending")
            const url = process.env.REACT_APP_USER_API_URL + "/support"
            const urlOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(form)           
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();
            
            if (response.status === 200) {
                setText("Success");
                setSent(true);
            } else {
                setText("Failed")
                alert("Status Code: " + response.status + " Error: " + data.detail);
            }

        } catch (error) {
            setText("Failed")
            alert("Error: " + error.message);
            console.log(error)
        }
    }

    useEffect(() => {
        setText("Send")
    }, [form])

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: "smooth" });
        }
    }, []);

    return (
        <>
            <div className="support-container" id="support">
                <span className="top-input" style={{ width: "auto" }}> Support </span>
                {
                    text === "Success" ?

                    <>
                    </>

                    :

                    <>
                        <input className="support-item" placeholder="your-email@example.com" value={form.email} onChange={(e) => setForm((prev) => ({...prev, email: e.target.value}))}/>
                        <textarea className="support-item" placeholder="Insert your question here." value={form.question} onChange={(e) => setForm((prev) => ({...prev, question: e.target.value}))} style={{ minHeight: "180px" }}/>
                    </>
                    
                }                
                <div className="send" onClick={() => submitForm()}>
                    { text }
                </div>
            </div>
        </>
    );
}

export default Support;